import { PasienTagByRm } from "@/types/daftarPasienPenunjang";

type TagAttribute = { activeText: string };

export function tagIndicatorByRm(
  tagByRm: PasienTagByRm | null | undefined,
  attr: Record<string, TagAttribute> & { default: TagAttribute }
): Record<string, string[]> {
  const hasil: Record<string, string[]> = {};

  Object.keys(tagByRm || {}).forEach(rm => {
    const tags = (tagByRm && tagByRm[rm]) || [];

    if (tags.length) {
      hasil[rm] = tags.map(it => (attr[it.name] || attr.default).activeText);
    }
  });

  return hasil;
}
